import { API_URL_ARTIST } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const featureArtist = (uuid: string) =>
  apiInstance({
    url: `${API_URL_ARTIST}${uuid}/featured`,
    method: "put",
  });

export default featureArtist;
